import { arrayOf, node, shape, string } from "prop-types";

import CallToAction from "../CallToAction/CallToAction.jsx";
import StyledLink from "../StyledLink/StyledLink.jsx";
import useMatchMedia from "../../common/useMatchMedia.js";

const propTypes = {
  title: string,
  description: node,
  promos: arrayOf(
    shape({
      eyebrow: string,
      title: string.isRequired,
      description: node.isRequired,
      images: arrayOf(
        shape({ src: string.isRequired, alt: string.isRequired }),
      ),
      link: string.isRequired,
      linkClass: string,
      linkTarget: string,
    }).isRequired,
  ).isRequired,
  link: shape({ children: string, href: string, target: string }),
};
const MultiPromoB = (props) => {
  const { title, description, promos, link } = props;

  const isDesktop = useMatchMedia("(min-width: 1060px)");

  return (
    <>
      {!isDesktop && (
        <div className="multi-promo__hr">
          <hr data-aos="border-grow" data-aos-once="true" />
        </div>
      )}
      <section className="multi-promo-b">
        <div className="multi-promo-b__header">
          {title && <h2 className="multi-promo-b__title">{title}</h2>}
          {description && (
            <div className="multi-promo-b__description">
              <div dangerouslySetInnerHTML={{ __html: description }}></div>
            </div>
          )}
        </div>
        <div className="multi-promo-b__promos">
          {promos.map((promo, i) => (
            <div key={i}>
              {promo.images.length > 0 && (
                <div className="multi-promo-b__promo-image">
                  <img
                    src={promo.images[0].src}
                    alt={promo.images[0].alt}
                    loading="lazy"
                  />
                </div>
              )}
              <div className="multi-promo-b__slide-content">
                {promo.eyebrow && (
                  <div
                    className="multi-promo-b__eyebrow"
                    data-aos="border-grow"
                    data-aos-once="true"
                  >
                    {promo.eyebrow}
                  </div>
                )}
                {promo.title && promo.linkClass && (
                  <div className="multi-promo-b__slide-title">
                    {promo.link && (
                      <a
                        href={promo.link}
                        className={promo.linkClass}
                        target={promo.linkTarget}
                      >
                        {promo.title}
                      </a>
                    )}
                    {!promo.link && promo.title}
                  </div>
                )}
                {promo.title && !promo.linkClass && (
                  <div className="multi-promo-b__slide-title">
                    {promo.link && (
                      <StyledLink href={promo.link} target={promo.linkTarget}>
                        {promo.title}
                      </StyledLink>
                    )}
                    {!promo.link && promo.title}
                  </div>
                )}
                {promo.description && (
                  <div className="multi-promo-b__slide-desc">
                    <div
                      dangerouslySetInnerHTML={{ __html: promo.description }}
                    ></div>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
        {link && (
          <div className="multi-promo-b__cta">
            <CallToAction
              className="call-to-action--outline"
              {...link}
              children={link.text}
            />
          </div>
        )}
      </section>
    </>
  );
};

MultiPromoB.propTypes = propTypes;
export default MultiPromoB;
